var _react_refresh_temp_1;
var _react_refresh_temp_2, _react_refresh_temp_3;
_react_refresh_temp_2 = $RefreshSig$();
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useReducer, } from 'react';
import { defaultTableState, TableActionVariant } from '../Table.constants';
import { tableReducer } from '../Table.reducer';
const TableContext = createContext(defaultTableState);
export const TableProvider = ({ children, isMultiSort = false, }) => {
    _react_refresh_temp_2();
    const [tableState, dispatch] = useReducer(tableReducer, {
        isMultiSort,
        isSelectAll: false,
        selected: [],
        sortConfig: [],
    });
    const deselect = useCallback((id) => {
        dispatch({
            type: TableActionVariant.DESELECT,
            value: id,
        });
    }, []);
    const deselectAll = useCallback(() => {
        dispatch({
            type: TableActionVariant.DESELECT_ALL,
        });
    }, []);
    const select = useCallback((id) => {
        dispatch({
            type: TableActionVariant.SELECT,
            value: id,
        });
    }, []);
    const selectAll = useCallback((idList) => {
        dispatch({
            type: TableActionVariant.SELECT_ALL,
            value: idList,
        });
    }, []);
    const setSort = useCallback((newSortConfigItem) => {
        dispatch({
            type: TableActionVariant.SET_SORT,
            value: newSortConfigItem,
        });
    }, []);
    const toggleSortOrder = useCallback((columnId) => {
        dispatch({
            type: TableActionVariant.TOGGLE_SORT_ORDER,
            value: columnId,
        });
    }, []);
    const value = useMemo(() => {
        return {
            deselect,
            deselectAll,
            select,
            selectAll,
            setSort,
            toggleSortOrder,
            ...tableState,
        };
    }, [
        deselect,
        deselectAll,
        select,
        selectAll,
        setSort,
        tableState,
        toggleSortOrder,
    ]);
    return (_jsx(TableContext.Provider, { value: value, children: children }));
};
_react_refresh_temp_1 = TableProvider;
$RefreshReg$(_react_refresh_temp_1, "TableProvider");
_react_refresh_temp_2(TableProvider, "Mzkf9Lwccapi6qVOkN4qvAw6PJ4=");
export const useTable = () => (_react_refresh_temp_3(), useContext(TableContext));
_react_refresh_temp_3(useTable, "gDsCjeeItUuvgOWf1v4qoK9RF6k=");
